import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import { ROLE_ADMIN } from '@/constants/enums';

const staticRoutes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/HomeView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/user/LoginView.vue'),
    meta: { title: '登录', requiresGuest: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/user/RegisterView.vue'),
    meta: { title: '注册', requiresGuest: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/user/ProfileView.vue'),
    meta: { title: '个人资料', requiresAuth: true }
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import(/* webpackChunkName: "wallet" */ '../views/user/WalletView.vue'),
    meta: { title: '我的钱包', requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import(/* webpackChunkName: "orders" */ '../views/user/OrdersView.vue'),
    meta: { title: '我的订单', requiresAuth: true }
  },
  {
    path: '/talent',
    name: 'talent',
    component: () => import(/* webpackChunkName: "talent" */ '../views/user/TalentListView.vue'),
    meta: { title: '才艺单' }
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '../views/user/ScheduleView.vue'),
    meta: { title: '日程' }
  },
  {
    path: '/marshmallows',
    name: 'marshmallows',
    component: () => import(/* webpackChunkName: "marshmallows" */ '../views/user/marshmallows/MarshmallowsView.vue'),
    meta: { title: '棉花糖' }
  },
  {
    path: '/marshmallows/write',
    name: 'marshmallows.write',
    component: () => import(/* webpackChunkName: "marshmallows" */ '../views/user/marshmallows/WriteView.vue'),
    meta: { title: '写棉花糖' }
  },
  {
    path: '/marshmallows/my',
    name: 'marshmallows.my',
    component: () => import(/* webpackChunkName: "marshmallows" */ '../views/user/marshmallows/MyView.vue'),
    meta: { title: '我的棉花糖', requiresAuth: true }
  },
  {
    path: '/marshmallows/topic/:topicId',
    name: 'marshmallows.topic',
    component: () => import('@/views/user/marshmallows/TopicConfirmView.vue'),
    meta: { title: '话题详情', hideNavbar: true }
  },
  {
    path: '/pointGift',
    name: 'pointGift',
    component: () => import(/* webpackChunkName: "pointGift" */ '../views/user/PointGiftView.vue'),
    meta: { title: '积分礼物' }
  },
  {
    path: '/userBotTask',
    name: 'userBotTask',
    component: () => import(/* webpackChunkName: "userBotTask" */ '../views/user/UserBotTaskView.vue'),
    meta: { title: '弹幕任务订阅', requiresAuth: true }
  },

  {
    path: '/game/sheep',
    name: 'sheepGame',
    component: () => import(/* webpackChunkName: "sheepGame" */ '../views/game/SheepGameView.vue'),
    meta: { title: '羊了个羊' }
  },

  {
    path: '/try/testHome',
    name: 'testHome',
    component: () => import('../views/try/testHomeView.vue'),
    meta: { title: '首页', hideNavbar: true }  // ← 新增 hideNavbar
  },

  {
    path: '/403',
    name: 'forbidden',
    component: () => import('../views/error/403.vue'),
    meta: { title: '禁止访问' }
  },
  {
    path: '/500',
    name: 'serverError',
    component: () => import('../views/error/500.vue'),
    meta: { title: '服务器错误' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/views/error/404.vue'),
    meta: { title: '页面未找到' }
  }
]

export const dynamicRoutes = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "admin" */'../views/admin/AdminLayout.vue'),
    meta: {
      title: '管理后台', requiresAuth: true, roles: [ROLE_ADMIN], hideNavbar: true
    },
    children: [
      {
        path: 'talentBack',
        name: 'admin.talent.back',
        component: () => import(/* webpackChunkName: "talentBack" */'../views/admin/TalentBackView.vue'),
        meta: { title: '才艺单管理', requiresAuth: true, roles: [ROLE_ADMIN] },
      },
      {
        path: 'weeklyBack',
        name: 'admin.weekly.back',
        component: () => import(/* webpackChunkName: "weeklyBack" */ '../views/admin/WeeklyBackView.vue'),
        meta: { title: '周表管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'scheduleBack',
        name: 'admin.schedule.back',
        component: () => import(/* webpackChunkName: "scheduleBack" */ '../views/admin/ScheduleBackView.vue'),
        meta: { title: '日程管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'marshmallowsBack',
        name: 'admin.marshmallows.back',
        component: () => import(/* webpackChunkName: "marshmallowsBack" */'../views/admin/MarshmallowsBackView.vue'),
        meta: { title: '棉花糖管理', requiresAuth: true, roles: [ROLE_ADMIN] },
      },
      {
        path: 'topicBack',
        name: 'admin.topic.back',
        component: () => import('@/views/admin/TopicBackView.vue'),
        meta: { title: '话题管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'pointGiftBack',
        name: 'admin.pointGift.back',
        component: () => import(/* webpackChunkName: "pointGiftBack" */ '../views/admin/PointGiftBackView.vue'),
        meta: { title: '积分礼物管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'boxExclusion',
        name: 'admin.boxExclusion',
        component: () => import('@/views/admin/BoxExclusionView.vue'),
        meta: { title: '盲盒排除列表', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'giftFlowBoxAssign',
        name: 'admin.giftFlowBoxAssign',
        component: () => import('@/views/admin/GiftFlowBoxAssignView.vue'),
        meta: { title: '流水盒归属修正', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'boxGiftStats',
        name: 'admin.boxGift.stats',
        component: () => import('@/views/admin/BoxGiftStatsView.vue'),
        meta: { title: '盲盒统计', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'orderManagement',
        name: 'admin.order.management',
        component: () => import(/* webpackChunkName: "orderManagement" */ '../views/admin/OrderManagementView.vue'),
        meta: { title: '订单管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'robotBack',
        name: 'admin.robot.back',
        component: () => import(/* webpackChunkName: "robotBack" */ '../views/admin/RobotBackView.vue'),
        meta: { title: '机器人管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'giftPointBack',
        name: 'admin.giftPoint.back',
        component: () => import(/* webpackChunkName: "giftPointBack" */ '../views/admin/GiftPointBackView.vue'),
        meta: { title: '礼物积分配置', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'userManagement',
        name: 'admin.user.management',
        component: () => import(/* webpackChunkName: "userManagement" */ '../views/admin/UserManagementView.vue'),
        meta: { title: '系统账户管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'biliAccounts',
        name: 'admin.bili.accounts',
        component: () => import(/* webpackChunkName: "biliAccounts" */ '../views/admin/BiliAccountManagementView.vue'),
        meta: { title: 'B站账户管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'bannerGenerator',
        name: 'admin.banner.generator',
        component: () => import('@/views/admin/BannerGeneratorView.vue'),
        meta: { title: '礼物横幅生成', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'taskline',
        name: 'admin.taskline.normal',
        component: () => import('@/views/admin/TaskNormalView.vue'),
        meta: { title: '任务线配置', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'taskline/lifecycle',
        name: 'admin.taskline.lifecycle',
        component: () => import('@/views/admin/TaskLifecycleView.vue'),
        meta: { title: '生命周期任务线', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'dataReconciliation',
        name: 'admin.data.reconciliation',
        component: () => import(/* webpackChunkName: "dataReconciliation" */ '../views/admin/DataReconciliationView.vue'),
        meta: { title: '数据补录', requiresAuth: true, roles: [ROLE_ADMIN] }
      },
      {
        path: 'userBotTaskAdmin',
        name: 'admin.userBotTask',
        component: () => import(/* webpackChunkName: "userBotTaskAdmin" */ '@/views/admin/UserBotTaskAdminView.vue'),
        meta: { title: '弹幕任务订阅管理', requiresAuth: true, roles: [ROLE_ADMIN] }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes: staticRoutes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated
  const userRoles = store.getters.getRoles

  if (to.path.startsWith('/admin')) {
    if (!isAuthenticated || !userRoles.includes('ROLE_ADMIN')) return next('/')
    if (!router.hasRoute('admin')) {
      dynamicRoutes.forEach(route => router.addRoute(route))
      return next({ ...to, replace: true })
    }
  }

  if (to.meta?.requiresAuth && !isAuthenticated) return next('/login')
  if (to.meta?.roles) {
    const requiredRoles = Array.isArray(to.meta.roles) ? to.meta.roles : [to.meta.roles];
    const hasRole = requiredRoles.some(role => userRoles.includes(role));
    if (!hasRole) return next('/403');
  }
  if (to.meta?.requiresGuest && isAuthenticated) return next('/')
  next()
})

export function initRoutes() {
  const roles = JSON.parse(localStorage.getItem('roles') || '[]')
  if (roles.includes('ROLE_ADMIN') && !router.hasRoute('admin')) {
    dynamicRoutes.forEach(route => router.addRoute(route))
  }
}

export default router